import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const SoldProductsNote = () => {
  return <Translation htmlAvailable text={getFormedEltTranslation('sold-products-note')} />
}
